import { useEffect, useState } from "react";
import { toast } from "sonner";
import { APARENCIA_PADRAO, type AparenciaDoCatalogo } from "@bookdental/schemas";
import { trpc } from "@/lib/trpc";

/** Rascunho da aparência do catálogo: a pré-visualização usa ele antes de salvar. */
export function useAparenciaDoCatalogo(ativo: boolean) {
  const utils = trpc.useUtils();
  const salva = trpc.catalogoPublico.aparencia.useQuery(undefined, { enabled: ativo });
  const [rascunho, setRascunho] = useState<AparenciaDoCatalogo | null>(null);
  // undefined = a capa salva continua; null = apagar; data URL = trocar.
  const [capa, setCapa] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    if (salva.data && !rascunho) setRascunho(salva.data.aparencia);
  }, [salva.data, rascunho]);

  const salvar = trpc.catalogoPublico.salvarAparencia.useMutation({
    onSuccess: async () => {
      await Promise.all([utils.catalogoPublico.aparencia.invalidate(), utils.catalogoPublico.visualizar.invalidate()]);
      setCapa(undefined);
      toast.success("Aparência do catálogo salva");
    },
    onError: (e) => toast.error(e.message),
  });

  const capaUrl = capa === undefined ? (salva.data?.capaUrl ?? null) : capa;
  const sujo = !!rascunho && !!salva.data && (JSON.stringify(rascunho) !== JSON.stringify(salva.data.aparencia) || capa !== undefined);

  const mudar = <K extends keyof AparenciaDoCatalogo>(chave: K, valor: Partial<AparenciaDoCatalogo[K]> | AparenciaDoCatalogo[K]) =>
    setRascunho((r) => {
      if (!r) return r;
      const atual = r[chave];
      const novo = atual && typeof atual === "object" && valor && typeof valor === "object" ? { ...atual, ...valor } : valor;
      return { ...r, [chave]: novo } as AparenciaDoCatalogo;
    });

  return {
    carregando: !rascunho,
    bloqueada: salva.data?.bloqueada ?? true,
    rascunho,
    capaUrl,
    sujo,
    salvando: salvar.isPending,
    mudar,
    setCapa,
    salvar: () => rascunho && salvar.mutate({ aparencia: rascunho, ...(capa !== undefined ? { capa } : {}) }),
    voltarAoPadrao: () => {
      setRascunho(APARENCIA_PADRAO);
      setCapa(salva.data?.capaUrl ? null : undefined);
    },
  };
}

export type EditorDeAparencia = ReturnType<typeof useAparenciaDoCatalogo>;
